import type { GatewayBrowserClient } from "../gateway.ts";
import type { AgentsListResult } from "../types.ts";

export type AgentsState = {
  client: GatewayBrowserClient | null;
  connected: boolean;
  agentsLoading: boolean;
  agentsList: AgentsListResult | null;
  lastError: string | null;
};

export async function loadAgents(state: AgentsState, opts?: { quiet?: boolean }) {
  if (!state.client || !state.connected) {
    return;
  }
  if (state.agentsLoading) {
    return;
  }
  state.agentsLoading = true;
  if (!opts?.quiet) {
    state.lastError = null;
  }
  try {
    state.agentsList = await state.client.request<AgentsListResult>("agents.list", {});
  } catch (err) {
    if (!opts?.quiet) {
      state.lastError = String(err);
    }
  } finally {
    state.agentsLoading = false;
  }
}
